import Comps from "./companies.json";
import MsComps from "./ms-companies.json";

export type Company = {
  CompanyID: number;
  Ticker: string;
  CompanyName: string;
  TickerCountry: string;
  "Bloomberg Ticker": string;
};

export interface CompaniesResponse {
  data: Daum[];
  meta: Meta;
}

interface Daum {
  id_bb_unique: string;
  snapshot: Snapshot;
  ticker: string;
}

interface Snapshot {
  ID_BB_TICKER: string;
  SECURITY_NAME: string;
  SH_COMPANY_ID?: number;
}

interface Meta {
  dumpId: string;
  fields: string[];
  requestedAt: string;
}

const companiesResponse: CompaniesResponse = Comps;
const MsCompanies: Company[] = MsComps;

export const Companies: (source: "MS" | "FT") => Company[] = (source) => {
  return source === "MS"
    ? MsCompanies
    : companiesResponse.data.map((c) => ({
        CompanyID: Math.floor(c.snapshot.SH_COMPANY_ID || 0),
        Ticker: c.ticker.split(" ")[0],
        CompanyName: c.snapshot.SECURITY_NAME,
        TickerCountry: c.snapshot.ID_BB_TICKER,
        "Bloomberg Ticker": c.snapshot.ID_BB_TICKER,
      }));
};

export const getCompany = (
  ticker: string,
  source: "MS" | "FT",
): Company | undefined => {
  return Companies(source).find((c) => c.TickerCountry === ticker);
};

export const getCompanyId = (
  ticker: string,
  source: "MS" | "FT",
): number | undefined => {
  return Companies(source).find((c) => c.TickerCountry === ticker)?.CompanyID;
};

export const getBloombergTickers = (source: "MS" | "FT"): string[] => {
  const tickers = Companies(source).map((c) => {
    const ticker = c["Bloomberg Ticker"];
    if (ticker) {
      return ticker;
    }
  });
  return tickers as string[];
};
